"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIHelpIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("./UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _passthroughProps = _interopRequireDefault(require("../utils/propTypes/passthroughProps"));

var _decorators = require("../utils/propTypes/decorators");

var USE_DARK = 'on-dark';
var USE_DEFAULT = 'default';

function UIHelpIcon(props) {
  var use = props.use,
      tooltipPlacement = props.tooltipPlacement,
      tooltipProps = props.tooltipProps,
      title = props.title,
      className = props.className,
      style = props.style,
      children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, ["use", "tooltipPlacement", "tooltipProps", "title", "className", "style", "children"]);
  var iconColor = use === USE_DARK ? _colors.OLAF : _colors.EERIE;
  var classes = (0, _classnames.default)('private-help-icon', className, {
    'private-help-icon--inline': children
  });
  return _react.default.createElement("span", {
    className: classes,
    style: style
  }, children, _react.default.createElement(_UITooltip.default, (0, _extends2.default)({}, tooltipProps, {
    placement: tooltipPlacement,
    title: title
  }), _react.default.createElement(_UIIcon.default, (0, _extends2.default)({
    className: "private-help-icon__icon",
    name: "info",
    color: iconColor
  }, rest))));
}

UIHelpIcon.defaultProps = {
  use: USE_DEFAULT
};
UIHelpIcon.propTypes = {
  size: _UIIcon.default.propTypes.size,
  color: _UIIcon.default.propTypes.color,
  use: _propTypes.default.oneOf([USE_DARK, USE_DEFAULT]),
  tooltipPlacement: (0, _decorators.notRequired)(_UITooltip.default.propTypes.placement),
  tooltipProps: (0, _passthroughProps.default)(_UITooltip.default),
  title: _propTypes.default.node.isRequired,
  children: _propTypes.default.node
};
UIHelpIcon.displayName = 'UIHelpIcon';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/icon/UIHelpIcon.js
// module id = 246
// module chunks = 5 6